import { LegacyIcon } from '@gonfalon/icons/LegacyIcon';
import type { LegacyIconProps } from '@gonfalon/icons/types';
import cx from 'clsx';

import CloudflareSvgColor from '../assets/cloudflare.svg';

export const CloudflareColor = ({ className, size, ...props }: LegacyIconProps) => (
  <LegacyIcon name="color-lang-cloudflare" className={cx('sdkIcon', className)} size={size} {...props}>
    <CloudflareSvgColor />
  </LegacyIcon>
);
